export default [
  'Academy Years',
  'In Uniform',
  'Post Military Life',
  '35th Reunion',
  '40th Reunion',
  '45th Reunion',
  '50th Reunion',
  'ALITC'
]
